import React from 'react';
import Comment from './Comment/index';
import CommentInput from './CommentInput/index';
import block from 'bem-cn-lite';

const Avatars = {
    cm: 'https://cdn.wrike.com/image/__cdnu/illustration_person_avatar_content_manager.svg',
    designer: 'https://cdn.wrike.com/image/__cdnu/illustration_person_avatar_designer.svg',
    marketer: 'https://cdn.wrike.com/image/__cdnu/illustration_person_avatar_marketer.svg',
    pm: 'https://cdn.wrike.com/image/__cdnu/illustration_person_avatar_project_manager.svg'
}

class Comments extends React.Component {
    shouldComponentUpdate(nextProps) {
        const {comments: prevComments, isVisibleCommentInput} = this.props;
        const {comments: nextComments} = nextProps;

        if (nextComments !== prevComments ||
            isVisibleCommentInput !== nextProps.isVisibleCommentInput) {
            return true;
        }

        return false;
    }

    render() {
        const b = block('Comments');
        const {
            isVisibleCommentInput,
            textAreaRef,
            comments,
            onSubmitCommentInput,
            userAvatar,
            onTrialLinkClick
        } = this.props;

        return (
            <div className={b()}>
                {
                    comments.map((comment, index) => {
                        return <Comment onTrialLinkClick={onTrialLinkClick} comment={comment} key={index}/>
                    })
                }
                {
                    isVisibleCommentInput &&
                    <CommentInput
                        avatar={userAvatar}
                        onEnter={onSubmitCommentInput}
                        textAreaRef={textAreaRef}/>
                }
            </div>
        )
    }
}

export {
    Comments,
    Avatars
};